import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';
import { StyledMachineStatsCardBase } from './MachineStatsCardBase.styles';
import { KpiCardBaseConfig } from 'app/modules/cleaning/widgets/machine-dashboard/types/MachineDashboard.types';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

interface MachineStatsCardBaseProps {
  config: KpiCardBaseConfig;
  isLoading: boolean;
  renderLeft: (isLoading: boolean) => React.ReactNode;
  renderRight?: () => React.ReactNode;
  renderEmpty?: () => React.ReactNode;
}

export const MachineStatsCardBase = ({
  config,
  isLoading,
  renderLeft,
  renderRight,
  renderEmpty,
}: MachineStatsCardBaseProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledMachineStatsCardBase className="machine-stats-card">
      <div className="machine-stats-card__header">
        <p className="machine-stats-card__title">{t(config.title)}</p>
        <Tooltip title={t(config.tooltip)} color="#1a1a1a" placement="top" trigger={['hover', 'click']}>
          <span>
            <SvgIcon name="information" className="machine-stats-card__title-icon" />
          </span>
        </Tooltip>
      </div>

      <div className="machine-stats-card__body">
        {renderEmpty ? (
          <div className="machine-stats-card__empty">{renderEmpty()}</div>
        ) : (
          <>
            <div className="machine-stats-card__left">{renderLeft(isLoading)}</div>
            {renderRight && <div className="machine-stats-card__right">{renderRight()}</div>}
          </>
        )}
      </div>
    </StyledMachineStatsCardBase>
  );
};
